module.exports = __webpack_public_path__ + "static/media/exukonline-bank.50d9081a.png";